<template>
  <!-- Kalkulation zum Produkt (Trello evD8Gwb4 Punkt 14): Angebot mit gleicher SKU, sonst die Angebote, die das Produkt enthalten -->
  <modal class-name="procurement-calc-modal" @close="$emit('close')">
    <template slot="header">
      <h4 class="modal-title">{{ row.sku }} – {{ $t("procurement.calcDialog.title") }}</h4>
      <md-button class="md-simple md-just-icon md-round modal-default-button" @click="$emit('close')"><md-icon>clear</md-icon></md-button>
    </template>
    <template slot="body">
      <div class="pcd">
        <div v-if="offers === null" class="pcd-hint">{{ $t("procurement.priceCell.calcLoading") }}</div>
        <div v-else-if="!offers.length" class="pcd-hint">{{ $t("procurement.calcDialog.noOffer") }}</div>
        <template v-else>
          <div v-if="offers.length > 1" class="pcd-select">
            <label>{{ $t("procurement.calcDialog.offer") }}</label>
            <select v-model="selectedId">
              <option v-for="o in offers" :key="o.offerId" :value="o.offerId">{{ optionText(o) }}</option>
            </select>
          </div>
          <div v-if="selected && !selected.isProductSku" class="pcd-note">
            <md-icon>info</md-icon>
            <span>{{ $t(offers.length > 1 ? "procurement.calcDialog.otherOffers" : "procurement.calcDialog.otherOffer", { sku: row.sku, offer: selected.offerSku, content: content(selected) }) }}</span>
          </div>
          <div v-else-if="selected" class="pcd-sub">{{ $t("procurement.calcDialog.ownOffer", { offer: selected.offerSku }) }}</div>
          <div v-if="calcState === 'error'" class="pcd-hint">{{ $t("procurement.priceCell.calcError") }}</div>
          <div v-else-if="!calc" class="pcd-hint">{{ $t("procurement.priceCell.calcLoading") }}</div>
          <offer-calc-detail v-else :calc="calc" />
        </template>
      </div>
    </template>
  </modal>
</template>
<script>
import { Modal } from "@/components";
import OfferCalcDetail from "@/components/OfferCalcDetail.vue";
import axiosFactory from "@/services/axios.factory";
import offersService from "@/services/offers.service";

export default {
  name: "ProcurementCalcDialog",
  components: { Modal, OfferCalcDetail },
  props: {
    row: { type: Object, required: true },
    // Kalkulationen je Angebots-Id, mit der Seite geteilt (auch "loading" / "error")
    calcCache: { type: Object, required: true },
  },
  data() {
    return { offers: null, selectedId: null };
  },
  computed: {
    selected() {
      return (this.offers || []).find((o) => o.offerId === this.selectedId) || null;
    },
    calcState() {
      const entry = this.calcCache[this.selectedId];
      return entry === "error" ? "error" : entry ? "ok" : "";
    },
    calc() {
      const entry = this.calcCache[this.selectedId];
      return entry && entry !== "error" && entry !== "loading" ? entry : null;
    },
  },
  watch: {
    selectedId(id) {
      this.loadCalc(id);
    },
  },
  created() {
    axiosFactory()
      .get(`/procurement/items/${this.row.productId}/offers`)
      .then((res) => {
        this.offers = (res.data && res.data.data) || [];
        // Angebot mit gleicher SKU, sonst das Angebot, dessen Marge die Zeile zeigt, sonst das erste
        const own = this.offers.find((o) => o.isProductSku);
        const shown = this.offers.find((o) => o.offerId === this.row.marginOfferId);
        const first = own || shown || this.offers[0];
        this.selectedId = first ? first.offerId : null;
      })
      .catch(() => {
        this.offers = [];
      });
  },
  methods: {
    loadCalc(id) {
      if (!id || this.calcCache[id]) return;
      this.$set(this.calcCache, id, "loading");
      offersService
        .getOfferCalculation(id)
        .then((calc) => this.$set(this.calcCache, id, calc))
        .catch(() => this.$set(this.calcCache, id, "error"));
    },
    content(offer) {
      return offer.positions.map((p) => `${p.quantity}× ${p.sku}`).join(", ");
    },
    optionText(o) {
      const db1 = o.db1Percent == null ? "–" : `${this.$options.filters.formatNumberGerman(o.db1Percent, 1)} %`;
      return `${o.offerSku} (${this.content(o)}) – DB1 ${db1}`;
    },
  },
};
</script>
<style>
.procurement-calc-modal {
  max-width: 560px !important;
}
.pcd {
  text-align: left;
  min-height: 80px;
}
.pcd-hint,
.pcd-sub {
  color: #777;
  font-size: 13px;
  margin-bottom: 8px;
}
.pcd-select {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 10px;
}
.pcd-select label {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.54);
}
.pcd-select select {
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 3px;
  font-size: 13px;
  background: #fff;
}
.pcd-note {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  background: #fff8e1;
  border: 1px solid #ffe082;
  border-radius: 4px;
  padding: 8px 10px;
  font-size: 13px;
  color: #6d4c00;
  margin-bottom: 10px;
}
.pcd-note .md-icon {
  color: #f9a825 !important;
  font-size: 18px !important;
  margin: 0;
}
</style>
